module.exports = __webpack_public_path__ + "img/logo2.12f94c82.png";